import { render, staticRenderFns } from "./attendanceTrainerList.vue?vue&type=template&id=2c470a52&scoped=true"
import script from "./attendanceTrainerList.vue?vue&type=script&lang=js"
export * from "./attendanceTrainerList.vue?vue&type=script&lang=js"
import style0 from "./attendanceTrainerList.vue?vue&type=style&index=0&id=2c470a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c470a52",
  null
  
)

export default component.exports